/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Empty_ClearInputs */

const en_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Filters`)
};

const es_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar filtros`)
};

const fr_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les filtres`)
};

const de_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter löschen`)
};

const ja_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`絞り込みをクリア`)
};

const zh_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除筛选`)
};

const ar_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسح عوامل التصفية`)
};

const id_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Filter`)
};

const it_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella Filtri`)
};

const ru_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить фильтры`)
};

const pt_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar Filtros`)
};

const ko_search_empty_clear = /** @type {(inputs: Search_Empty_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`필터 초기화`)
};

/**
* | output |
* | --- |
* | "Clear Filters" |
*
* @param {Search_Empty_ClearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_empty_clear = /** @type {((inputs?: Search_Empty_ClearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Empty_ClearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_empty_clear(inputs)
	if (locale === "es") return es_search_empty_clear(inputs)
	if (locale === "fr") return fr_search_empty_clear(inputs)
	if (locale === "de") return de_search_empty_clear(inputs)
	if (locale === "ja") return ja_search_empty_clear(inputs)
	if (locale === "zh") return zh_search_empty_clear(inputs)
	if (locale === "ar") return ar_search_empty_clear(inputs)
	if (locale === "id") return id_search_empty_clear(inputs)
	if (locale === "it") return it_search_empty_clear(inputs)
	if (locale === "ru") return ru_search_empty_clear(inputs)
	if (locale === "pt") return pt_search_empty_clear(inputs)
	return ko_search_empty_clear(inputs)
});